












import { defineComponent } from '@nuxtjs/composition-api'
import { defineVue3AsyncComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    PrivacyPolicyEl: defineVue3AsyncComponent(() =>
      import('~/components/car/information/privacy-policy/PrivacyPolicyEl.vue')
    ),
    PrivacyPolicyEn: defineVue3AsyncComponent(() =>
      import('~/components/car/information/privacy-policy/PrivacyPolicyEn.vue')
    )
  },
  head() {
    return {
      title: this.$t('privacy') as string
    }
  }
})
